// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-dcf0becf] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation-input-confirm[data-v-dcf0becf] {
  flex: 1 0 100%;
  width: 100%;
}
.app-navigation-input-confirm form[data-v-dcf0becf] {
  display: flex;
}
.app-navigation-input-confirm__input[data-v-dcf0becf] {
  height: 34px;
  flex: 1 1 100%;
  font-size: 100% !important;
  margin: 5px 5px 5px -8px !important;
  padding: 7px !important;
}
.app-navigation-input-confirm__input[data-v-dcf0becf]:active,
.app-navigation-input-confirm__input[data-v-dcf0becf]:focus,
.app-navigation-input-confirm__input[data-v-dcf0becf]:hover {
  outline: none;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  border-color: var(--color-primary-element);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcInputConfirmCancel-45d1d76b.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,mCAAmC;EACnC,uBAAuB;AACzB;AACA;;;EAGE,aAAa;EACb,8CAA8C;EAC9C,6BAA6B;EAC7B,0CAA0C;AAC5C","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-dcf0becf] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation-input-confirm[data-v-dcf0becf] {\n  flex: 1 0 100%;\n  width: 100%;\n}\n.app-navigation-input-confirm form[data-v-dcf0becf] {\n  display: flex;\n}\n.app-navigation-input-confirm__input[data-v-dcf0becf] {\n  height: 34px;\n  flex: 1 1 100%;\n  font-size: 100% !important;\n  margin: 5px 5px 5px -8px !important;\n  padding: 7px !important;\n}\n.app-navigation-input-confirm__input[data-v-dcf0becf]:active,\n.app-navigation-input-confirm__input[data-v-dcf0becf]:focus,\n.app-navigation-input-confirm__input[data-v-dcf0becf]:hover {\n  outline: none;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  border-color: var(--color-primary-element);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
